















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import {
  AttivitaRequest,
  DATE_FROM_NULL,
  DATE_TO_NULL,
} from "@/data/models/attivita.model";

import { AttivitaService } from "@/data/services/attivita.service";
import { date2Num, Listitem } from "yellowfin-ui-lib";

@Component({})
export default class AttivitaSearch extends Vue {
  @Inject("AttivitaService") ativitaService!: AttivitaService;

  searchparam: AttivitaRequest;
  loading: boolean = false;
  commissioni?: Listitem[];
  settori?: Listitem[];

  dal!: Date | undefined;
  al!: Date | undefined;

  enabledcolsconf: string = process.env.VUE_APP_CORSI_COLONNE as string;
  enabledcols = {
    titolo: true,
    data: true,
    tipo: true,
    settore: true,
    durata: true,
    costo: true,
    cfp: false,
    posti: true,
    iscrizione: true,
    sede: true,
  };

  @Prop() all: "all" | "current" | "future" | undefined;

  @Watch("all")
  onDataChange() {
    console.log("onDataChange");

    this.reset();

    this.search();
  }

  constructor() {
    super();
    this.searchparam = new AttivitaRequest();
  }

  get config() {
    const conf = process.env.VUE_APP_SEARCH;
    return conf ? JSON.parse(conf) : {};
  }

  beforeMount() {
    if (this.enabledcolsconf) {
      const enabledcols = this.enabledcolsconf.split(",");
      if (enabledcols) {
        this.enabledcols = enabledcols.reduce((acc: any, c: string) => {
          acc[c] = true;
          return acc;
        }, {});
      }
    }

    this.loadOpzioni();
    this.reset();
  }

  loadOpzioni() {
    this.loading = true;
    const commissionis = this.ativitaService.getAttivitaCommissioni();
    const settoris = this.ativitaService.getAttivitaSettori();
    Promise.all([commissionis, settoris])
      .then((results) => {
        this.commissioni = results[0];
        this.settori = results[1];
      })
      .finally(() => {
        this.loading = false;
      });
  }

  search() {
    if (this.al) {
      this.al.setHours(23);
      this.al.setMinutes(59);
    }
    this.searchparam.finedal = this.dal ? date2Num(this.dal) : DATE_FROM_NULL;

    this.searchparam.fineal = this.al ? date2Num(this.al) : DATE_TO_NULL;
    this.$emit("search", this.searchparam);
  }

  reset() {
    this.searchparam = new AttivitaRequest();
    this.searchparam.direction = "asc";
    const now = new Date();
    if (this.all !== "all") {
      this.dal = new Date();
      if (this.all === "current") {
        this.al = new Date(
          now.getFullYear(),
          now.getMonth() + 2,
          1,
          23,
          59,
          0,
          0
        );
      } else {
        this.al = undefined;
      }
    } else {
      this.dal = undefined;
      this.al = undefined;
    }
    this.search();
  }
}
